import {
  USER_LOGGED_IN,
  SUBSCRIBE_POSITION_UPDATES,
  UNSUBSCRIBE_POSITION_UPDATES,
  ORDER_UPDATE_ENTRY,
  ALGO_STATUS_UPDATE,
  HEALTH_STATUS,
  SUBSCRIBE_LITE_POSITION_UPDATES,
  UNSUBSCRIBE_LITE_POSITION_UPDATES,
  BROKER_STATUS_UPDATE,
  SUBSCRIBE_UNDERLYING_LIVE_FEED,
  UNSUBSCRIBE_UNDERLYING_LIVE_FEED,
  ANNOUNCEMENT_UPDATE,
  SUBSCRIBE_CHART_PNL_LIVE_FEED,
  UNSUBSCRIBE_CHART_PNL_LIVE_FEED,
  SUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED,
  UNSUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED,
} from './ActionTypes';

export default {
  user_login: USER_LOGGED_IN,
  subscribe_position_updates: SUBSCRIBE_POSITION_UPDATES,
  unsubscribe_position_updates: UNSUBSCRIBE_POSITION_UPDATES,
  position_updates: SUBSCRIBE_POSITION_UPDATES,
  order_update: ORDER_UPDATE_ENTRY,
  algo_status_update: ALGO_STATUS_UPDATE,
  get_health_status: HEALTH_STATUS,
  subscribe_lite_position_updates: SUBSCRIBE_LITE_POSITION_UPDATES,
  unsubscribe_lite_position_updates: UNSUBSCRIBE_LITE_POSITION_UPDATES,
  position_lite_updates: SUBSCRIBE_LITE_POSITION_UPDATES,
  broker_status_update: BROKER_STATUS_UPDATE,
  subscribe_underlying_live_feed: SUBSCRIBE_UNDERLYING_LIVE_FEED,
  unsubscribe_underlying_live_feed: UNSUBSCRIBE_UNDERLYING_LIVE_FEED,
  announcement_update: ANNOUNCEMENT_UPDATE,
  subscribe_pnl_graph_update: SUBSCRIBE_CHART_PNL_LIVE_FEED,
  unsubscribe_pnl_graph_update: UNSUBSCRIBE_CHART_PNL_LIVE_FEED,
  subscribe_underlying_pnl_graph_update:
    SUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED,
  unsubscribe_underlying_pnl_graph_update:
    UNSUBSCRIBE_UNDERLYINNG_CHART_PNL_LIVE_FEED,
};
